<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-2 col-md-12 col-2 mb-3">
                    <h2>Unprocessed Data </h2>
                    </div>
                    <div class="col-lg-10 col-5 text-right">
                        <button type="button" @click="ticketProcess()" class="btn btn-success rounded ml-1">
                            <i v-if="!processing" class="fa fa-paper-plane"></i> 
                            <!-- <i v-if="exporting" class="fa fa-spinner fa-spin"></i> -->
                            <span v-if="!processing">PROCESS</span>
                            <!-- <span v-if="exporting">EXPORTING...</span> -->
                            </button>
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive" style="min-height:200px">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <div v-if="filesList.length == 0 && !loading">
                            <p style="color:black">No Unprocessed Data </p>
                        </div>
                        <p id="files-area">
                            <span id="filesList">
                            <span id="files-names" v-for="data in filesList" :key="data.id">
                                <span class="file-block">
                                <span v-if="isProcessCompleted != 'INPROGRESS'" class="file-delete" @click="removeFile(data.Key)">
                                    <span>+</span>
                                </span>
                                <span class="name" style="margin:5px">{{data.Key.split(cognitoSub).pop()}}</span>
                                </span>
                            </span>
                            </span>
                        </p>
                        <!-- <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >File Name</th>                  
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="filesList.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in filesList" :key="data.id">
                                <td>{{data.Key.split("/").pop()}}</td>
                            </tr>
                            </tbody>
                        </table>-->
                        <div class="total-records">
                            <span>Total Records : {{filesList.length}}</span>
                        </div> 
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import AWS from 'aws-sdk/global';
import config from "@/config";
import authService from "@/authService";

export default {
  name: "unprocessed",
  components : {
    
  },
  data() {
    return {
        filesList : [],
        accessToken : null,
        loading: false,
        processing : false,
        cognitoSub: authService.getUser().cognitoSub,
        isProcessCompleted : localStorage.getItem("TICKETING_PROCESS")

    };
  },
  methods: {
    removeFile(keyName){
        let self = this;
        var message = `Are you sure you want to delete this file?`;
        this.$confirm(message,"Delete","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            var s3 = new AWS.S3();
            var params = {  Bucket: config.albumBucketNameIms, Key: keyName };
            s3.deleteObject(params, function(err) {
                if (err) console.log(err, err.stack);  // error
                else  { self.getFiles()}               // deleted
            });
        })
        
    },
    ticketProcess(){
        var message = `Are you sure you want to process uploaded files?`;
          this.$confirm(message,"Process","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
            let addData = {"mode": "PROCESS" ,"cognitoSub" : authService.getUser().cognitoSub};
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()}
            };
            this.$http
            .post(config.baseUrlBidSide + "/ticket-catalogue/process", addData, auth)
            .then(() => {
                this.loading = false;  
                localStorage.setItem("TICKETING_PROCESS", "INPROGRESS"); 
                this.isProcessCompleted =  localStorage.getItem("TICKETING_PROCESS")             
                this.$alert("Processing Started","","success");
                // this.$emit('close');               
            })
            .catch(() => {
                this.loading = false;              
            });
            
          });
    },
    getFiles(){
        let self = this;
        var s3 = new AWS.S3({
            apiVersion: "2006-03-01",
            params: { Bucket: "imsfileupload"}
        });
        var params = {
            Bucket: config.albumBucketNameIms, /* required */
            Prefix: "ticket_catalogue/to_be_processed/"+authService.getUser().cognitoSub  // Can be your folder name
        };
        s3.listObjectsV2(params, function(err, data) {
            if (err) {console.log(err, err.stack);self.loading = false,self.showSessionReloadPoup()} // an error occurred
            else {
                self.filesList = data.Contents;
                self.loading = false

            }     
        });
    }
   
  },
  mounted() {
      this.loading = true;
      let self = this;
      this.$cognitoAuth.getIdToken((err, result) => {
          if (err) {
              console.log("accessToken is not found", err);
          } else {
              this.accessToken = result;
          }
      });
      const userPoolLoginKey = config.userPoolLoginKey;
      const logins = {};
      logins[userPoolLoginKey] = this.accessToken;
      AWS.config.region = config.region;
      const cognitoParams = {
          IdentityPoolId: config.IdentityPoolIdFileUpload,
          Logins: logins
      };
      let cognitoidentity = new AWS.CognitoIdentity();
      cognitoidentity.getId(cognitoParams, function(err, data) {
          if (err) {
              console.log(err);
              self.showSessionReloadPoup();
          } else {
              console.log(data.IdentityId);
              let bucketRegion = AWS.config.region;
              AWS.config.update({
              region: bucketRegion,
              credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
              });
              self.getFiles();
          }
      });

      this.$root.$on("TICKETINGPROCESSCOMPLETED", () => {
        this.isProcessCompleted = null;
      });
      
    }
};
</script>
<style scoped>

.preview-body{
    padding: 0.5rem !important;
  }
  #files-area{
    margin: 0 auto;
    font-size: 10px !important;
    width: 90% !important;
  }
  .file-block{
    border-radius: 10px;
    background-color: rgba(144, 163, 203, 0.2);
    margin: 5px;
    color: initial;
    display: inline-flex;
  }
  .file-block.span.name{
		padding-right: 10px;
		width: max-content;
		display: inline-flex;
    margin: 5px;
	}
  .file-delete{
    display: flex;
    width: 24px;
    color: initial;
    background-color: #6eb4ff00;
    font-size: large;
    justify-content: center;
    margin-right: 3px;
    cursor: pointer;
  }
  .file-delete:hover{
		background-color: rgba(144, 163, 203, 0.2);
		border-radius: 10px;
	}
  .file-delete > span{
        transform: rotate(45deg);
    }
</style>